// extracted by mini-css-extract-plugin
export default {"carousel":"LocationSection_carousel__beXVB","location":"LocationSection_location__ZCkc0"};